import { render } from "./ContractExpirationUpdate.vue?vue&type=template&id=4901246c&scoped=true"
import script from "./ContractExpirationUpdate.vue?vue&type=script&lang=js"
export * from "./ContractExpirationUpdate.vue?vue&type=script&lang=js"

import "./ContractExpirationUpdate.vue?vue&type=style&index=0&id=4901246c&scoped=true&lang=css"

import exportComponent from "C:\\frotend\\d7m_front_end\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4901246c"]])

export default __exports__